import { render, staticRenderFns } from "./ContentWatcher.vue?vue&type=template&id=be11fcda&"
import script from "./ContentWatcher.vue?vue&type=script&lang=js&"
export * from "./ContentWatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports